import React from 'react';
import { CAMPAIGN_MERGE_FIELDS, MERGE_FIELD_CATEGORIES } from '@/lib/campaignMergeFields';
import { Button } from '@/components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ChevronDown, Copy } from 'lucide-react';
import { toast } from 'sonner';

interface Props {
  onInsert: (fieldKey: string) => void;
}

const MergeFieldPicker: React.FC<Props> = ({ onInsert }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const copyField = (key: string) => {
    navigator.clipboard.writeText(`{{${key}}}`);
    toast.success(`Copied {{${key}}}`);
  };

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger asChild>
        <Button variant="outline" size="sm" className="w-full justify-between">
          Merge Fields
          <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent className="mt-2 border rounded-lg p-3 space-y-3">
        {MERGE_FIELD_CATEGORIES.map(cat => {
          const fields = CAMPAIGN_MERGE_FIELDS.filter(f => f.category === cat.key);
          if (!fields.length) return null;
          return (
            <div key={cat.key}>
              <div className="text-xs font-semibold text-muted-foreground mb-1">{cat.label}</div>
              <div className="flex flex-wrap gap-1">
                {fields.map(f => (
                  <div key={f.key} className="flex items-center gap-0.5">
                    <Button variant="secondary" size="sm" className="text-xs h-7 px-2" onClick={() => onInsert(f.key)} title={`${f.description} — e.g. ${f.example}`}>
                      {`{{${f.key}}}`}
                    </Button>
                    <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => copyField(f.key)}>
                      <Copy className="h-3 w-3" />
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </CollapsibleContent>
    </Collapsible>
  );
};

export default MergeFieldPicker;
